export const orderFieldsSettingsTypes = {
    setting_name: 'name',
    setting_type: 'type',
    setting_configuration: 'configuration',
    setting_default_value: 'default_value',
    setting_required: 'required',
};

export const orderFieldsSettingsValues = {
    name: 'Имя поля',
    type: 'Тип поля',
    configuration: 'Значения',
    default_value: 'По умолчанию',
    required: 'Обязательное',
};

export const orderFieldsTypes = {
    field_input: 'input',
    field_textarea: 'textarea',
    field_select: 'select',
    // field_file: 'file',
};

export const orderFieldsValues = {
    input: 'Строка текста',
    textarea: 'Блок текста',
    select: 'Селект',
    // file: 'Файл',
};

export const actionsTimesTypes = {
    time_0: "0",
    time_15: "15",
    time_30: "30",
    time_45: "45",
    time_60: "60",
};

export const actionsTimesValues = {
    0: 'Сразу',
    15: 'Через 15 минут',
    30: 'Через 30 минут',
    45: 'Через 45 минут',
    60: 'Через 1 час',
};

export const actionsTypes = {
    type_sms: 'sms',
    type_task: 'task',
    // type_move_to_next_status: 'move_to_next_status',
    // type_webhook: 'webhook',
};

export const actionsTypesValues = {
    sms: 'Отправка СМС',
    task: 'Задача сотруднику',
    // move_to_next_status: 'Перевод в следующий статус',
    // webhook: 'Webhook-запрос',
};

export const sendMailResourceTypes = {
    type_email: 'email',
    type_chat_bot: 'chat_bot',
};

export const sendMailResourceValues = {
    email: 'E-mail',
    chat_bot: 'Чат-бот',
};

export const smsAssigneeTypes = {
    type_order_client: 'order_client',
    type_order_manager: 'order_manager',
    type_company_owner: 'company_owner',
};

export const smsAssigneeValues = {
    order_client: 'Клиенту',
    order_manager: 'Менеджеру',
    company_owner: 'Владельцу компании',
};

export const taskAssigneeTypes = {
    type_order_manager: 'order_manager',
    type_company_owner: 'company_owner',
};

export const taskAssigneeValues = {
    order_manager: 'Менеджеру',
    company_owner: 'Владельцу компании',
};

export const taskAuthorTypes = {
    type_order_manager: 'order_manager',
    type_company_owner: 'company_owner',
};

export const taskAuthorValues = {
    order_manager: 'Менеджер',
    company_owner: 'Владелец компании',
};
